import { useRef } from 'react'
import { Link } from 'react-router-dom'
import SectionLabel from '../SectionLabel'
import TrekCard from '../TrekCard'
import { treks } from '../../data/treks'

export default function TrekSimilarTreks({ trek }) {
  const others = treks.filter(t => t.id !== trek.id)
  const rowRef = useRef(null)
  const scroll = dir => rowRef.current?.scrollBy({ left: dir * 320, behavior: 'smooth' })

  if (!others.length) return null

  return (
    <section className="section" style={{ background: 'var(--white)' }}>
      <SectionLabel>Similar Treks</SectionLabel>
      <h2 className="section-title">You might also like.</h2>

      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '20px', marginBottom: '32px' }}>
        <button className="scroll-arrow" onClick={() => scroll(-1)} aria-label="Previous">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <div ref={rowRef} className="scroll-row" style={{ flex: 1 }}>
          {others.map((t, i) => (
            <div key={t.id} className="scroll-row-item" style={{ width: '300px' }}>
              <TrekCard trek={t} index={i} />
            </div>
          ))}
        </div>
        <button className="scroll-arrow" onClick={() => scroll(1)} aria-label="Next">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>
      </div>

      <div style={{ textAlign: 'center' }}>
        <Link to="/#treks" className="btn btn-slate">View All Treks</Link>
      </div>
    </section>
  )
}
